import { Chip } from "framework7-react";

const TagChip = ({ name, color, selected = false, className, onClick }) => (
  <Chip
    className={["tag-chip", selected && "tag-chip-selected", className]
      .filter(Boolean)
      .join(" ")}
    style={color ? { "--tag-color": color } : undefined}
    text={name}
    onClick={onClick}
  />
);

export default TagChip;
